import { useEffect } from 'react';

export default function useWidget(upsellWidgetUrl: string) {
  useEffect(() => {
    if (upsellWidgetUrl) {
      const script = document.createElement('script');
      script.src = upsellWidgetUrl;
      script.defer = true;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [upsellWidgetUrl]);
}
